/**
 * Enhanced Language Detection for Chinese Users
 * Detects browser language and redirects accordingly on first visit
 * Stores preference to avoid repeated redirects
 */

(function() {
  'use strict';

  // Configuration
  const STORAGE_KEY = 'office-aio-lang-detected';
  const LANGUAGES = {
    zh: '/zh',
    en: '/en'
  };

  /**
   * Check if user has Chinese language preference
   */
  function isChinesePreferred() {
    const userLanguages = navigator.languages || [navigator.language || navigator.userLanguage];
    
    return userLanguages.some(lang => {
      const langCode = lang.toLowerCase();
      // Match zh, zh-cn, zh-hans, zh-tw, zh-hk, etc.
      return langCode.startsWith('zh');
    });
  }

  /**
   * Get current language from URL
   */
  function getCurrentLanguage() {
    const path = window.location.pathname;
    if (path.startsWith('/zh')) return 'zh';
    if (path.startsWith('/en')) return 'en';
    return null;
  }

  /**
   * Check if we're on the homepage (root or with trailing slash)
   */
  function isHomepage() {
    const path = window.location.pathname;
    return path === '/' || path === '';
  }

  /**
   * Perform language detection and redirect if needed
   */
  function detectAndRedirect() {
    // Only run on first visit to homepage
    if (!isHomepage()) return;

    // Check if we've already detected language
    const hasDetected = sessionStorage.getItem(STORAGE_KEY);
    if (hasDetected) return;

    // Mark as detected to prevent loops
    sessionStorage.setItem(STORAGE_KEY, 'true');

    // Determine preferred language
    const preferredLang = isChinesePreferred() ? 'zh' : 'en';
    const currentLang = getCurrentLanguage();

    // Only redirect if not already on the correct language
    if (currentLang !== preferredLang) {
      // Small delay to ensure smooth transition
      setTimeout(() => {
        window.location.href = LANGUAGES[preferredLang];
      }, 100);
    }
  }

  // Run detection when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectAndRedirect);
  } else {
    detectAndRedirect();
  }

})();

